import axios from 'axios';
import {toast} from 'react-toastify';

export const service = axios.create({
	withCredentials: true
});

const handleSuccess = (response) => {
	return response.data;
}

const handleError = async (error) => {
	switch (error.response.status) {
		case 401:
			redirectTo('/logout/1')
			break;
		case 404:
			redirectTo('/')
			break;
	}
	if (error.response) {
		console.error('Request error', error.response);
		toast.error(error.response.data.message)
	} else if (error.request) {
		console.error('Request error', error.request);
		toast.error(error.request);
	} else {
		console.error('Error', error.message);
	}

	return Promise.reject(error)
}

const redirectTo = (path) => {
	window.location = path;
}

service.interceptors.response.use(handleSuccess, handleError);

const get = (path, params = {}) => {
	return service.get(path, {
		params: params
	}).then((response) => {
		return response
	});
}

const put = (path, payload) => {
	return service.request({
		method: 'PUT',
		url: path,
		responseType: 'json',
		data: payload
	}).then((response) => {
		return response
	});
}

const post = (path, payload) => {
	return service.request({
		method: 'POST',
		url: path,
		responseType: 'json',
		data: payload
	}).then((response) => {
		return response
	});
}

export default {
	get,
	put,
	post
};